/**
 *
 * @module contentClientExtrasMap
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    greater
} = Check.assert;

/**
 *
 * @class ContentClientExtrasMap
 * @desc Provides extra data used by the ContentClient
 *
 */
export default class ContentClientExtrasMap {

    /**
     *
     * @param {Number} urlSizeLimit
     *
     */
    constructor(urlSizeLimit) {

        const errorMessage = {
            ctor: 'ContentClientExtrasMap(urlSizeLimit)',
            get urlSizeLimit() {
                return `${this.ctor} urlSizeLimit should be a Number greater than 0`;
            }
        };

        greater(
            urlSizeLimit,
            0,
            errorMessage.urlSizeLimit,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets the maximum size of the URL that can be used for GET operations.
         *
         */
        this.urlSizeLimit = urlSizeLimit;

    }

}



// WEBPACK FOOTER //
// ./src/services/content/contentClientExtrasMap.js